import { render, staticRenderFns } from "./OsButton.vue?vue&type=template&id=7f6e29cc&scoped=true"
import script from "./OsButton.vue?vue&type=script&lang=ts"
export * from "./OsButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6e29cc",
  null
  
)

export default component.exports